import PrivacyPolicy from '../../container/PolicyPages/PrivacyPolicy';

function TermsConditions() {
  return <PrivacyPolicy />;
}

export default TermsConditions;
